module.exports = __webpack_public_path__ + "static/media/13@1920w.ec7ff4df.jpg";